import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js';
import { Box, Stack } from '@mui/material';
import SimpleTable from './simpleTable';
const Grafico = ({ title, bgColor, borderColor, type, showTable, labels, values }) => {
    const chartRef = useRef(null);
    const chartInstanceRef = useRef(null);
    const createChart = () => {
        if (chartRef.current) {
            const ctx = chartRef.current.getContext('2d');
            if (ctx) {
                // Destroi gráfico anterior antes de criar novo
                if (chartInstanceRef.current) {
                    chartInstanceRef.current.destroy();
                }
                const plugin = {
                    id: 'customCanvasBackgroundColor',
                    beforeDraw: (chart, args, options) => {
                        const { ctx } = chart;
                        ctx.save();
                        ctx.globalCompositeOperation = 'destination-over';
                        ctx.fillStyle = options.color || '#99ffff';
                        ctx.fillRect(0, 0, chart.width, chart.height);
                        ctx.restore();
                    }
                };
                const dataChart = {
                    labels,
                    datasets: [
                        {
                            label: title,
                            backgroundColor: bgColor,
                            borderColor: borderColor,
                            borderWidth: 2,
                            fill: false,
                            data: values,
                            type
                        }
                    ]
                };
                chartInstanceRef.current = new Chart(ctx, {
                    type,
                    data: dataChart,
                    options: {
                        responsive: true,
                        legend: {
                            display: true,
                            position: 'top',
                            labels: {
                                boxWidth: 20,
                                padding: 15
                            }
                        },
                        tooltips: {
                            mode: 'index',
                            intersect: false
                        },
                        scales: {
                            yAxes: [
                                {
                                    ticks: {
                                        beginAtZero: true,
                                        callback: (value) => new Intl.NumberFormat('pt-PT').format(value)
                                    }
                                }
                            ]
                        },
                        plugins: {
                            customCanvasBackgroundColor: {
                                color: 'white'
                            }
                        }
                    },
                    plugins: [plugin]
                });
            }
        }
    };
    useEffect(() => {
        createChart();
        return () => {
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
            }
        };
    }, [labels, values, type]); // ← type incluído aqui
    return (<Box>
      <Stack direction="column" spacing={2}>
        <Box sx={{
            borderRadius: '15px',
            border: '1px solid #e0e0e0',
            overflow: 'hidden',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
            bgcolor: 'white'
        }}>
          <canvas ref={chartRef}/>
        </Box>
        {showTable ? <SimpleTable colunas={labels} dados={values}/> : null}
      </Stack>
    </Box>);
};
export default Grafico;
